import {
    mapActions,
    mapGetters
} from 'vuex';
import ConfirmationI18n from './Confirmation.i18n.js';

export default {

    components: {},

    props: {},

    computed: {
        ...mapGetters(['codesDevis', 'isDownloading'])
    },

    data() {
        return {

        };
    },

    watch: {},

    methods: {
        ...mapActions(['downloadFacture']),
        /**
         * Fonction pour revenir à l'acceuil
         */
        goToHome() {
            this.$router.push('/');
        },
        /**
         * Fonction pour télécharger la facture.
         */
        downloadCurrentFacture() {
            const codesDevis = {
                ListeCodeEnteteDevis: this.codesDevis
            }
            this.downloadFacture(codesDevis).then(res => {

            }).catch(err => {
                console.log(err)
                this.notify('error', 'Erreur', "La facture n'a pas pu être téléchargée. Veuillez réessayer plus tard ou essayez depuis la page 'factures archivées'")
            })
        }
    },

    mounted() {},

    i18n: ConfirmationI18n,

};
